import React, { useEffect, useState } from "react";
import ReusableModal from "../../../../components/Modals/ReusableModal";
import { useUpdateProviderMutation } from "../../../../features/provider/providerApiSlice";
import { useSelector } from "react-redux";
import { selectUser } from "../../../../features/auth/authSlice";
import { useCreateLogsMutation } from "../../../../features/logs/logsApiSlice";
import {
  ACTIVITY_STATUS,
  ACTIVITY_TYPE,
  // languages,
} from "../../../../constants/config.constants";
import languages from '../../../../constants/languages.json'
import StateManagedSelect from "react-select";
import Select from "react-select";

const ProviderUpdate = ({ open, setOpen, setData, data }) => {
  const user = useSelector(selectUser);
  const [provider, setProvider] = useState(data);
  const [updateProvider, { isLoading: updateProviderLoading }] =
    useUpdateProviderMutation();
  const [createLog] = useCreateLogsMutation();

  const languageOptions = languages
    .sort((a, b) => a.english.localeCompare(b.english))
    .map((language) => ({
      label: language.english,
      value: language.english,
      iso: language.iso639_2b,
    }));

  const handleChange = (e) => {
    setProvider({ ...provider, [e.target.name]: e.target.value });
  };

  const handleUpdateProvider = async () => {
    const payload = {
      activity: `Provider (${provider.name}) updated by User ${user?.details?.name}`,
      type: ACTIVITY_TYPE.PROVIDER_UPDATE,
      data: {
        providerId: provider.id,
      },
    };
    try {
      const { data } = await updateProvider({
        ...provider,
        providerId: provider.id,
      }).unwrap();
      setData((prev) => ({ ...prev, ...data }));
      await createLog({
        ...payload,
        status: ACTIVITY_STATUS.SUCCESS,
      }).unwrap();
    } catch (error) {
      console.error(error?.data?.message);
      await createLog({
        ...payload,
        status: ACTIVITY_STATUS.FAILED,
      }).unwrap();
    }
  };

  useEffect(() => {
    setProvider({
      ...data,
      languagePreference: data?.languagePreference || "English",
    });
  }, [data]);

  return (
    <ReusableModal
      open={open}
      title={"Edit provider"}
      onClose={() => {
        setOpen(false);
      }}
    >
      <div className="flex flex-col items-center min-w-[480px]">
        <div className="h-[1px] w-full bg-primarygrayborder" />
        <div className="flex flex-col w-full gap-4 p-6 overflow-auto max-h-[calc(100vh-200px)]">
          <div className="flex flex-col gap-2">
            <label
              htmlFor="languagePreference"
              className="m-0 text-base font-semibold"
            >
              Primary Language Preference
            </label>
            {/* <select
              id="languagePreference"
              name="languagePreference"
              value={provider.languagePreference}
              onChange={handleChange}
              className="w-full p-2 border-[1px] border-primarygray rounded-md outline-none"
            >
              {languages.map((language) => (
                <option value={language.english} key={language.iso639_2b}>
                  {language.english}
                </option>
              ))}
            </select> */}
            <StateManagedSelect
              id="languagePreference"
              name="languagePreference"
              options={languageOptions}
              value={languageOptions.find((opt) => opt.value === provider.languagePreference)}
              placeholder="Select Primary Language Preference"
              onChange={(selectedOption) =>
                handleChange({
                  target: {
                    name: 'languagePreference',
                    value: selectedOption?.value || '',
                  },
                })
              }
              isSearchable
              isClearable
              className="w-full border-[1px] border-primarygray rounded-md outline-none"
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({
                  ...base,
                  zIndex: 9999,
                }),
              }}
            />
          </div>
          <div className="flex flex-col gap-2">
            <label
              htmlFor="languagePreference"
              className="m-0 text-base font-semibold"
            >
              Secondary Language Preference
            </label>
            {/* <select
              id="secondaryLanguagePreference"
              name="secondaryLanguagePreference"
              value={provider.secondaryLanguagePreference}
              onChange={handleChange}
              className="w-full p-2 border-[1px] border-primarygray rounded-md outline-none"
            >
              <option value={"None"}>None</option>
              {languages.map((language) => (
                <option value={language.english} key={language.iso639_2b}>
                  {language.english}
                </option>
              ))}
            </select> */}
            <StateManagedSelect
              options={languages.map((language) => ({
                label: language.english,
                value: language.english,
              }))}
              value={
                provider.secondaryLanguagePreference
                  ? provider.secondaryLanguagePreference
                      .split(",")
                      .map((language) => ({
                        label: language,
                        value: language,
                      }))
                  : null
              }
              onChange={(e) => {
                setProvider({
                  ...provider,
                  secondaryLanguagePreference: e
                    .map((language) => language.value)
                    .join(","),
                });
              }}
              placeholder="Select Secondary Language Preference"
              isMulti
              isSearchable
              isClearable
              className="w-full border-[1px] border-primarygray rounded-md outline-none"
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({
                  ...base,
                  zIndex: 9999,
                }),
              }}
            />
          </div>
        </div>
        <div className="justify-end w-full px-3 mb-2 d-flex">
          <button
            // disabled={!provider.languagePreference}
            className="w-[120px]  disabled:opacity-40 disabled:cursor-not-allowed font-semibold p-1 border-[2px] rounded-md bg-subtleblue border-primaryblue text-primaryblue whitespace-nowrap"
            onClick={async () => {
              await handleUpdateProvider();
              setOpen(false);
            }}
          >
            {updateProviderLoading ? "Saving..." : "Save"}
          </button>
        </div>
      </div>
    </ReusableModal>
  );
};

export default ProviderUpdate;
